import React from 'react';
import logo from './logo.svg';
import './App.css';
import AppRoutes from 'AppRoutes';

function App() {
  return (
    <AppRoutes/>
  );
}

export default App;
